import { type TFunction } from "i18next";
import { z } from "zod";

const getChangePinFormObjectSchema = (t: TFunction) =>
  z.object({
    currentPin: z.string().min(6, t("choosePin_subtitle")),
    newPin: z.string().min(6, t("choosePin_subtitle")),
    newPinConfirmation: z.string().min(6, t("choosePin_subtitle")),
  });

export const getChangePinFormSchema = (t: TFunction) =>
  getChangePinFormObjectSchema(t).refine(
    (data) => data.newPin === data.newPinConfirmation,
    {
      message: t("error_notMatchedPin"),
      path: ["newPinConfirmation"],
    }
  );

export type ChangePinFormSchema = z.infer<
  ReturnType<typeof getChangePinFormSchema>
>;

export type ChangePinFormFieldName = keyof ChangePinFormSchema;

const identityT = ((key: string) => key) as TFunction;

export const CHANGE_PIN_FIELD_NAMES = Object.keys(
  getChangePinFormObjectSchema(identityT).shape
) as readonly ChangePinFormFieldName[];
